import { Component, Input, OnInit, inject } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { Encounter } from '../../../core/models/encounter.model';
import { Patient } from '../../../core/models/patient.model';
import { Referral } from '../../../core/models/referral.model';
import { PatientService } from '../../../core/services/patient.service';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { EncounterListComponent } from '../../../capture-admin/components/encounter-list/encounter-list.component';
import { EncounterTableDirective } from '../../../capture-admin/components/encounter-list/encounter-table.directive';

@Component({
    selector: 'app-validate-patient-care-ownership',
    templateUrl: './validate-patient-care-ownership.component.html',
    styleUrls: ['./validate-patient-care-ownership.component.scss'],
    imports: [EncounterListComponent, EncounterTableDirective, TitleCasePipe, DatePipe]
})
export class ValidatePatientCareOwnershipComponent implements OnInit {
  private patientService = inject(PatientService);

  @Input() capture: Capture;

  patient: Patient;
  closestPatientInteractionEhrIdentifier: string;
  closestPatientInteractionDate: string;
  closestPatientInteractionType: string;
  closestPatientInteractionProviderName: string;
  closestPatientInteractionLocation: string;
  closestPatientInteractionEncounterType: string;
  closestPatientInteractionValid: boolean;
  patientInteractionIsVerified: boolean;

  fetchPatientEncounters = (paging: any, eligible: boolean) =>
    this.patientService.pagedEncounters(this.patient.id, eligible, paging);

  ngOnInit() {
    if (this.capture.verifyingEncounter) {
      this.setClosestPatientInteractionDataFromEncounter(this.capture.verifyingEncounter, true);
    } else if (this.capture.closestEncounter) {
      this.setClosestPatientInteractionDataFromEncounter(
        this.capture.closestEncounter,
        this.capture.closestEncounterValid
      );
    }
    this.patientInteractionIsVerified = !!this.capture.verifyingEncounter || !!this.capture.verifyingReferral;
    this.patientService.get(this.capture.patient.id).subscribe(patient => {
      this.patient = patient;
    });
  }

  setClosestPatientInteractionDataFromEncounter(encounter: Encounter, valid: boolean) {
    this.closestPatientInteractionType = 'ENCOUNTER';
    this.closestPatientInteractionEhrIdentifier = encounter.ehrIdentifier;
    this.closestPatientInteractionDate = encounter.encounterDate;
    this.closestPatientInteractionProviderName = this.encounterProviderFullName(encounter);
    this.closestPatientInteractionLocation = encounter.location;
    this.closestPatientInteractionEncounterType = encounter.encounterType;
    this.closestPatientInteractionValid = valid;
  }

  encounterProviderFullName(encounter: Encounter) {
    return `${encounter.providerFirst} ${encounter.providerLast} (NPI ${encounter.providerNpi})`;
  }

  referralProviderFullName(referral: Referral) {
    return `${referral.sendingProviderFirst} ${referral.sendingProviderLast} (NPI ${referral.sendingProviderNpi})`;
  }

  get patientOwnershipTimeframeInMonths(): number {
    return this.capture.client.patientOwnershipTimeframeInMonths;
  }
}
